<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('Patient profile')}}</span>
          </div>
        </div>
        <hr class="small-hr">
        <div class="content">
          <p>{{$t('uername')}}:<span>{{profile.username}}</span></p>
          <p v-show="isA">{{$t('Patient ID')}}:<span style="margin-left: 36px;">0000001</span></p>
        </div>
        <div class="content content1">
          <p>{{$t('Portrait')}}:</p>  <img :src="portrait">
        </div>
        <div class="content content1">
          <p>{{$t('fullName')}}: <span style="margin-left: 20px;">{{profile.realname}}</span></p>
        </div>
        <div class="content content1">
          <p>{{$t('Alias')}}: </p><input  v-model="alias"  :placeholder='alias'>
        </div>
        <div class="content content1">
          <p>{{$t('Mobile')}}:<span>{{profile.mobile}}</span></p>
        </div>
        <div class="content content1">
          <p>{{$t('Telephone')}}: <span style="margin-left: 15px;">{{profile.telephone}}</span></p>
        </div>
        <div class="content content1">
          <p>{{$t('Email')}}:<span>{{profile.email}}</span></p>
        </div>

        <hr class="small-hr">

        <div class="operate">
          <button class="cancel" @click="back">{{$t('Cancel')}}</button>
          <button class="create" @click="create">{{$t('save')}}</button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data(){
      return{
        isA:false, profile:'',Remark:false,isM:false,alias:'',
      }
    },
    computed:{
      portrait(){
        return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('patientId'))+'/portrait'
      }
    },
    methods:{
      back(){
        this.$router.push('/monitor')
      },
      create(){
        let info = {
            data:{
              alias:this.alias,
            }
        };
        let Pid = parseInt(sessionStorage.getItem('patientId'));
        auth.modifyPatientProfile2(this,Pid,info);
      },
    },
    mounted(){
      let Pid = parseInt(sessionStorage.getItem('patientId'));
      auth.getPatientProfile3(this,Pid);
    },
  }
</script>

<style scoped>
  .newPatient-container{
    height:100%;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:100%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  .main-container{
    width:97%;
    height:783px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .content{
    width: 96%;
    margin:0 auto;
  }
  .content p{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    margin-bottom: 20px;
    letter-spacing:-0.39px;
  }
  .content span{
    color:#0082d2;
    margin-left: 30px;
    letter-spacing:-0.29px;
  }
  .content1{
    height: 25px;
    margin-top: 30px;
    clear: both;
  }
  .content1 p{
    float: left;
  }
  .content1 img{
    background:#c9c9c9;
    border-radius:100px;
    width:51px;
    height:50px;
    float: left;
    margin:-15px 130px 0 50px;
  }
  .content1 .text{
    margin-right: 145px;
  }
  .content1 span{
    margin-left: 20px;
  }
  .content input{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:120px;
    height:28px;
    margin-top: -4px;
    margin-left: 20px;
    padding-left: 6px;
    color:#282828;
    font-family:SFUIText-Regular;
    font-size: 16px;
  }
  input::-webkit-input-placeholder{
    color: #0082d2;
  }
  .operate{
    width: 50%;
    float: right;
    margin-top:100px;
    margin-bottom: 20px;
    margin-right: 10px;
  }
  .operate button{
    background: transparent;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
    float: right;
  }
  .operate .create{
    margin-right: 20px;
  }

</style>



// WEBPACK FOOTER //
// patientProfile-carer.vue?3ec45c20